module.exports = __webpack_public_path__ + "static/media/sample_lmloadshare.207f9ff8.csv";